






































































































































































































import {
	Component,
	Prop,
	Vue
} from 'vue-property-decorator';
import DxDropDownBox from 'devextreme-vue/drop-down-box';
import BaseMixin from '@/components/mixins/base';
import DxList from 'devextreme-vue/list';
import DxSelectBox from 'devextreme-vue/select-box';
import DxButton from 'devextreme-vue/button';
import DxTextBox from 'devextreme-vue/text-box';
import DxAutocomplete from 'devextreme-vue/autocomplete';
import CaptionedField from './captioned-field.vue';
import {
	apiService,
	customerService,
	uiBus,
	authorizationService
} from '@/container';
import {
	BaseCubeMember,
	TCubeDimension,
	TCubeMeasure
} from '@cubejs-client/core';
import FilterBuilder from './filter-builder.vue';
import TimeDimensionSelection from './time-dimension-selection.vue';
import { cloneDeep, first, isEqual, isNil, sortBy, isArray, isEmpty, debounce } from 'lodash';
import moment from 'moment';
import { SortingDirection, ISortingFieldComboboxValue, ValidatedQuery, ChartType } from './types';
import {
	ChartConfigVersion, getDefaultChartConfig, getDefaultLatestVersionChartConfig, IChartConfig,
	pushAxisDimensionSafelyInConfig, pushLegendDimensionSafelyInConfig, pushMeasuresDimensionSafelyInConfig,
	removeDimensionFromAxisIfPresent
} from '@/components/charts/resultSetTransform';


@Component({
	components: {
		DxSelectBox,
		DxList,
		DxDropDownBox,
		DxButton,
		DxTextBox,
		DxAutocomplete,
		CaptionedField,
		FilterBuilder,
		TimeDimensionSelection
	}, name: 'ChartCreateQueryFields'
})
export default class ChartCreateQueryFields extends BaseMixin {
	@Prop({ type: Array, required: true }) availableMeasures!: TCubeMeasure[]
	@Prop({ type: Array, required: true }) availableDimensions!: TCubeDimension[]
	@Prop({ type: Array, default: () => [] }) filters!: any[];
	@Prop({ type: Array, default: () => [] }) measures!: any[];
	@Prop({ type: Array, default: () => [] }) timeDimensions!: any[];
	@Prop({ type: Array, default: () => [] }) globalDimensions?: any[];
	@Prop({ type: Object }) granularity!: any;
	@Prop({ type: Array }) globalFilter!: any[];
	@Prop({ type: String }) chartType!: string;
	@Prop({ type: Number }) index!: number;
	@Prop({ type: Boolean }) isQueryVisible!: boolean;

	// @Prop({ type: Array, default: () => [] }) axisDimensions!: TCubeDimension[];
	// @Prop({ type: Array, default: () => [] }) legendDimensions!: TCubeDimension[];

	@Prop({ type: Function, default: () => () => void 0 }) setFilters!: (cubeFilter: any) => void;
	@Prop({ type: Function, default: () => () => void 0 }) setMeasures!: (measure: any[]) => void;
	@Prop({ type: Function, default: () => () => void 0 }) setDimensions!: (dim: any[]) => void;
	@Prop({ type: Function, default: () => () => void 0 }) setTimeDimensions!: (dim: any[]) => void;
	@Prop({ type: Function, default: () => () => void 0 }) updateChartType!: (chartType: string) => void;
	@Prop({ type: Object, default: () => ({}) }) config!: IChartConfig | null;
	@Prop({ type: Boolean }) useWeek!: boolean | null;
	@Prop({ type: Boolean, default: false }) canRemove!: boolean;
	@Prop({ type: Object }) validatedQuery!: ValidatedQuery;
	@Prop({ type: Function, default: () => () => void 0 }) setOrder!: (obj: any) => void;

	isMeasuresDropDownBoxOpened = false;
	isDimensionsDropDownBoxOpened = false;
	isTimeDimensionDropDownBoxOpened = false;
	isDefaultOrderBy = true;
	loading = false;
	genericFields: string[] = [];
	internalTimeDimensionIds: string[] = [];
	dateRange: any = null;
	internalFilter: any[] = [];
	internalChartConfig: IChartConfig = getDefaultLatestVersionChartConfig();
	userSelectionWatcherAlreadySet = false;
	user = authorizationService.getCurrentUser();
	selectedFieldForSorting: any = {};
	onSortingChangedEvent = 'onSortingChanged';
	onAxisChangedEvent = 'onAxisChanged';
	onUserSelectionChanged = 'onUserSelectionChanged';
	onLegendChangedEvent = 'onLegendChanged';
	onTitleChangedEvent = 'onTitleChanged';
	isQueryVisibleInternal;

	async created(): Promise<void> {

		const dateRange = this.getvalueFilterIfPresent();
		if (!isNil(dateRange) && !isNil(dateRange.value) && !isNil(dateRange.value.filter))
			this.dateRange = dateRange.value.filter;

		this.isQueryVisibleInternal = this.isQueryVisible;
		if (isNil(this.isQueryVisibleInternal))
			this.isQueryVisibleInternal = false;
		var customer = customerService.getCustomer();
		if (customer != null) {
			this.genericFields = await apiService.get('datamart', `genericFieldsByCustomer/${customer}`);
			this.$emit('update:genericFields', this.genericFields);
			this.$watch(() => this.granularity, val => {
				if (!isNil(val) && !isNil(val.granularity) && !isNil(val.dimension)) {
					this.onChangeTimeDimensionsDropDownBoxValue();
				} else {
					this.setTimeDimensions([]);
					this.dateRange = null;
				}
			}, { immediate: true });
		}

		Vue.prototype.$isweek = false;

		this.$watch(() => this.validatedQuery, (data) => {
			const order = data.order;
			if (!order) {
				return;
			}
			this.setSelectedFieldForSortingIfPossible();

		}, { immediate: true });

		this.$watch(() => this.config, (config, oldConfig) => {
			if (config === oldConfig)
				return;
			if (isNil(config)) {
				this.internalChartConfig = getDefaultChartConfig();
				//this.onUserSelectionsChanged(this.userSelections, null);
			}
			else if (!isEqual(config, this.internalChartConfig)) {
				this.internalChartConfig = cloneDeep(config);
			}

			if (!this.userSelectionWatcherAlreadySet) {
				this.$watch(() => this.userSelections, (val, oldVal) => debounce((val, oldVal) => this.onUserSelectionsChanged(val, oldVal), 1000));
				this.userSelectionWatcherAlreadySet = true;
			}
		});

		this.$watch(() => this.internalChartConfig, (newChartConfig, oldChartconfig) => {
			if (isEqual(newChartConfig, oldChartconfig))
				return;
			this.$emit('update:config', cloneDeep(newChartConfig));
		});
	}

	getvalueFilterIfPresent() {
		return {
			value: !isNil(this.timeDimensions) && isArray(this.timeDimensions) && this.timeDimensions.length > 0
				? { filter: (this.timeDimensions[0].dateRange || null) }
				: null
		};
	}
	mounted() {
		this.$watch(() => [this.globalFilter, this.internalFilter], val => {
			let combinedFilter: any = {};
			const isGlobalFilterDefined = !isNil(this.globalFilter) && isArray(this.globalFilter) && this.globalFilter.length > 0;
			const isInternalFilterDefined = !isNil(this.internalFilter) && isArray(this.internalFilter) && this.internalFilter.length > 0;
			if (isGlobalFilterDefined && isInternalFilterDefined)
				combinedFilter = {
					and: [...this.globalFilter, ...this.internalFilter]
				};
			else if (isGlobalFilterDefined)
				combinedFilter = this.globalFilter[0];
			else if (isInternalFilterDefined)
				combinedFilter = this.internalFilter[0];
			else
				combinedFilter = {};

			this.setFilters([combinedFilter]);
		}, { immediate: true });

		this.$watch(() => this.config, (config) => {
			if (isNil(config)) {
				this.internalChartConfig = getDefaultChartConfig();
				this.onUserSelectionsChanged(this.userSelections, null);
			}
			else if (!isEqual(config, this.internalChartConfig)) {
				this.internalChartConfig = cloneDeep(config);
			}

			if (!this.userSelectionWatcherAlreadySet) {
				this.$watch(() => this.userSelections, this.onUserSelectionsChanged);
				this.userSelectionWatcherAlreadySet = true;
			}
		}, { immediate: true });

		this.$watch(() => this.internalChartConfig, (newChartConfig, oldChartconfig) => {
			if (isEqual(newChartConfig, oldChartconfig))
				return;
			this.$emit('update:config', cloneDeep(newChartConfig));
		});

		this.$watch(() => this.globalDimensions, val => {
			if (isNil(val))
				this.setDimensions([]);
			else
				this.setDimensions(val.map(x => x.name));
		}, { immediate: true, deep: true });

		this.$watch(() => this.chartType, val => {
			this.updateChartType(isNil(val) ? 'line' : val);
		}, { immediate: true });

		uiBus.on(this.onSortingChangedEvent, selectedValue => {
			const selectedItem = this.fieldsForSortingDataSource.find(x => x.displayValue === selectedValue);
			this.setOrder(selectedItem ? { [selectedItem.key]: selectedItem.value } : {});
		});

		uiBus.on(this.onAxisChangedEvent, (selectedvalue: { addedItems: TCubeDimension[], removedItems: TCubeDimension[] }) => {
			const config = cloneDeep(this.internalChartConfig);
			if (Array.isArray(selectedvalue.removedItems) && selectedvalue.removedItems.length) {
				const toRemove = new Set(selectedvalue.removedItems.map(ri => ri.name));
				config.axisDimensions = config.axisDimensions.filter(cd => !toRemove.has(cd.name));
			}
			if (Array.isArray(selectedvalue.addedItems)) {
				Array.prototype.push.apply(config.axisDimensions, selectedvalue.addedItems.filter(ai => !this.axisDimensionsSet.has(ai.name)));
				const toRemoveFromLegend = new Set(selectedvalue.addedItems.map(ri => ri.name));
				config.legendDimensions = config.legendDimensions.filter(cd => !toRemoveFromLegend.has(cd.name));
			}
			if ((config.version || -1) <= ChartConfigVersion.AxisAndLegends)
				config.version = ChartConfigVersion.AxisAndLegends;
			this.internalChartConfig = config;
		});

		uiBus.on(this.onLegendChangedEvent, (selectedvalue: { addedItems: TCubeDimension[], removedItems: TCubeDimension[] }) => {
			const config = cloneDeep(this.internalChartConfig);
			if (Array.isArray(selectedvalue.removedItems) && selectedvalue.removedItems.length) {
				const toRemove = new Set(selectedvalue.removedItems.map(ri => ri.name));
				config.legendDimensions = config.legendDimensions.filter(cd => !toRemove.has(cd.name));
			}
			if (Array.isArray(selectedvalue.addedItems)) {
				Array.prototype.push.apply(config.legendDimensions, selectedvalue.addedItems.filter(ai => !this.legendDimensionsSet.has(ai.name)));
				const toRemoveFromAxis = new Set(selectedvalue.addedItems.map(ri => ri.name));
				config.axisDimensions = config.axisDimensions.filter(cd => !toRemoveFromAxis.has(cd.name));
			}
			if ((config.version || -1) <= ChartConfigVersion.AxisAndLegends)
				config.version = ChartConfigVersion.AxisAndLegends;
			this.$set(this, 'internalChartConfig', config);
		});

		uiBus.on(this.onUserSelectionChanged, (val: { currentVal, oldVal }) => {
			const config = cloneDeep(this.internalChartConfig);

			const rawCurrentVal = {
				dimensions: val.currentVal.dimensions && val.currentVal.dimensions.map(x => x.name),
				measures: val.currentVal.measures && val.currentVal.measures.map(x => x.name),
				timeDimensions: val.currentVal.timeDimensions && val.currentVal.timeDimensions.map(x => `${x.name}.${x.granularity}`)
			};
			const rawOldVal = {
				dimensions: val.oldVal.dimensions && val.oldVal.dimensions.map(x => x.name),
				measures: val.oldVal.measures && val.oldVal.measures.map(x => x.name),
				timeDimensions: val.oldVal.timeDimensions && val.oldVal.timeDimensions.map(x => `${x.name}.${x.granularity}`)
			};
			//console.log('selectionChnaged', cloneDeep(rawCurrentVal), cloneDeep(rawOldVal), isEqual(rawCurrentVal, rawOldVal), JSON.stringify(rawCurrentVal) === JSON.stringify(rawOldVal));
			if (isEqual(rawCurrentVal, rawOldVal))
				return;

			const { isDimensionSet, isTimeDimensionSet, isMeasuresSet } = this.parseUserSelection(val.currentVal, val.oldVal);
			if (isMeasuresSet) {
				pushMeasuresDimensionSafelyInConfig(config, val.currentVal.measures);
			}

			if (isDimensionSet) {
				config.selectedDimensions = [...val.currentVal.dimensions];

				if (isTimeDimensionSet) {
					removeDimensionFromAxisIfPresent(config, val.currentVal.dimensions);
					pushAxisDimensionSafelyInConfig(config, val.currentVal.timeDimensions[0]);
					pushLegendDimensionSafelyInConfig(config, val.currentVal.dimensions);
				} else {
					const legendsThatMustBeKept = config.legendDimensions.filter(x => val.currentVal.dimensions.map(y => y.name).includes(x.name));
					pushAxisDimensionSafelyInConfig(config, val.currentVal.dimensions.filter(x => !legendsThatMustBeKept.map(y => y.name).includes(x.name)), { clearBeforePush: true });
					pushLegendDimensionSafelyInConfig(config, legendsThatMustBeKept, { clearBeforePush: true });
				}
			}

			this.internalChartConfig = config;
		});

		uiBus.on(this.onTitleChangedEvent, (newTitle: string) => {
			const config = cloneDeep(this.internalChartConfig);
			config.title = newTitle;
			this.$set(this, 'internalChartConfig', config);
		});

		if (isEmpty(this.validatedQuery.order) && (isNil(this.selectedFieldForSorting) || isEmpty(this.selectedFieldForSorting)))
			this.selectedFieldForSorting = this.fieldsForSortingDataSource.map(x => x.displayValue)[0];
		else {
			this.isDefaultOrderBy = false;
			this.setSelectedFieldForSortingIfPossible();
		}

	}

	get availableMeasuresFiltered() {
		return this.filterAndMapFields(this.availableMeasures);
	}

	get availableDimensionsFiltered() {
		return this.filterAndMapFields(this.availableDimensions);
	}

	/**
	 * https://cube.dev/docs/query-format#time-dimensions-format
	 */
	get availableTimeDimensions() {
		return ([{
			name: 'today',
			value: 0,
			kind: 'days'
		}, {
			name: 'yesterday',
			value: -1,
			kind: 'days'
		}, {
			name: 'lastWeek',
			value: -7,
			kind: 'days'
		}, {
			name: 'lastMonth',
			value: -1,
			kind: 'months'
		}, {
			name: 'lastYear',
			value: -1,
			kind: 'years'
		}, {
			name: 'next2Month',
			value: +2,
			kind: 'months'
		}, {
			name: 'nextYear',
			value: +1,
			kind: 'years'
		},
		{
			name: 'lastMonthAndNextMonth',
			value: +30,
			kind: 'months'
		},
		{
			name: 'last2MonthAndNext2Month',
			value: +31,
			kind: 'months'
		},
		{
			name: 'last6MonthAndNext6Month',
			value: +32,
			kind: 'months'
		},
		{
			name: 'lastYearAndNextYear',
			value: +33,
			kind: 'years'
		}

		] as Array<{
			name: string,
			value: number,
			kind: 'days' | 'weeks' | 'months' | 'quarter' | 'years'
		}>).map(dt => {
			let filter = `from ${-1 * dt.value} ${dt.kind} ago to now`;
			if (dt.value > 0 && dt.value < 15)
				filter = `from now to ${dt.value} ${dt.kind} from now`;
			else if (dt.value === 0)
				filter = 'today';
			else if (dt.name === 'lastMonthAndNextMonth') {
				filter = `from ${(moment().subtract(1, 'month').format('MM-DD-YYYY'))} to ${(moment().add(1, 'month').format('MM-DD-YYYY'))}`;
			}
			else if (dt.name === 'last2MonthAndNext2Month') {
				filter = `from ${(moment().subtract(2, 'month').format('MM-DD-YYYY'))} to ${(moment().add(2, 'month').format('MM-DD-YYYY'))}`;
			}
			else if (dt.name === 'last6MonthAndNext6Month') {
				filter = `from ${(moment().subtract(6, 'month').format('MM-DD-YYYY'))} to ${(moment().add(6, 'month').format('MM-DD-YYYY'))}`;
			}
			else if (dt.name === 'lastYearAndNextYear') {
				filter = `from ${(moment().subtract(1, 'year').format('MM-DD-YYYY'))} to ${(moment().add(1, 'year').format('MM-DD-YYYY'))}`;
			}
			return {
				name: dt.name,
				filter
			};
		});
	}

	get genericFieldsDictionary(): Record<string, boolean> {
		const result: Record<string, boolean> = {};
		this.genericFields.forEach(gf => {
			result[gf] = true;
		});
		return result;
	}

	get userSelections() {
		return {
			measures: this.measures,
			dimensions: this.globalDimensions,
			timeDimensions: getCleanTimeDimension(this.timeDimensions)
		};

		function getCleanTimeDimension(td) {
			if (isNil(td) || !isArray(td) || td.length === 0)
				return [];

			return td.map(x => {
				if (!isNil(x.dimension) && !isNil(x.dimension.granularities))
					delete x.dimension.granularities;
				return {
					granularity: x.granularity,
					index: x.index,
					...x.dimension
				};
			});
		}
	}

	get fieldsForSortingDataSource(): ISortingFieldComboboxValue[] {
		const { measures = [], dimensions = [] } = this.validatedQuery;

		const selectedAxisDimensions = this.internalChartConfig.axisDimensions || [];
		const selectedAxisDimensionsCount = selectedAxisDimensions.length;

		const selectedLegendDimensions = this.internalChartConfig.legendDimensions || [];


		const translate = this.$t;
		const ascResult: ISortingFieldComboboxValue[] = [];
		const descResult: ISortingFieldComboboxValue[] = [];
		const ascTDResult: ISortingFieldComboboxValue[] = [];
		const descTDResult: ISortingFieldComboboxValue[] = [];

		const timeDimension = cloneDeep((this.timeDimensions || [])[0]);
		const timeDimensionsMapped = this.timeDimensions.map(x => x.dimension);
		const isSelectedTimeDimension = !isNil(timeDimension);

		if (isSelectedTimeDimension) {
			Array.prototype.push.apply(ascTDResult, timeDimensionsMapped.map(sortAscDescription));
			Array.prototype.push.apply(descTDResult, timeDimensionsMapped.map(sortDescDescription));
		}

		if (selectedLegendDimensions.length === 0) {
			Array.prototype.push.apply(descResult, measures.map(sortDescDescription));
			Array.prototype.push.apply(ascResult, measures.map(sortAscDescription));
			if (selectedAxisDimensionsCount === 0) {
				Array.prototype.push.apply(descResult, dimensions.map(sortDescDescription));
				Array.prototype.push.apply(ascResult, dimensions.map(sortAscDescription));
			}
			else if (!isSelectedTimeDimension) {
				const axisDim = first(selectedAxisDimensions)!;
				if (axisDim.type !== 'time') {
					descResult.push(sortDescDescription(axisDim));
					ascResult.push(sortAscDescription(axisDim));
				}
			}
		}
		else {
			Array.prototype.push.apply(descResult, measures.map(sortDescDescription));
			Array.prototype.push.apply(ascResult, measures.map(sortAscDescription));
			const legendDim = first(selectedLegendDimensions)!;
			if (selectedLegendDimensions.every(ld => ld.type !== 'time')) {
				descResult.push(sortDescDescription(legendDim));
				ascResult.push(sortAscDescription(legendDim));
			}
			if (selectedAxisDimensionsCount >= 1) {
				const axisDim = first(selectedAxisDimensions)!;
				if (selectedAxisDimensions.every(ad => ad.type !== 'time')) {
					descResult.push(sortDescDescription(axisDim));
					ascResult.push(sortAscDescription(axisDim));
				}
			}
		}

		// Order is important, as explained in cubejs docs, time dimension by default will be ASC first, measures DESC first
		// If we respect these orderings, we won't broke older graphs
		return [
			...ascTDResult,
			...descTDResult,
			...descResult,
			...ascResult,
		];

		function sortAscDescription(measureOrDimension: string | TCubeDimension): ISortingFieldComboboxValue {
			let code = measureOrDimension as string;
			if (!_.isString(measureOrDimension))
				code = measureOrDimension.name;
			return {
				displayValue: `${translate(code)} ${SortingDirection.ASC.toUpperCase()}`,
				key: code,
				value: SortingDirection.ASC
			};
		}
		function sortDescDescription(measureOrDimension: string | TCubeDimension) {
			let code = measureOrDimension as string;
			if (!_.isString(measureOrDimension))
				code = measureOrDimension.name;
			return {
				displayValue: `${translate(code)} ${SortingDirection.DESC.toUpperCase()}`,
				key: code,
				value: SortingDirection.DESC
			};
		}
	}

	get isAxisAndLegendsSelectionAvailable() {
		return this.chartType === ChartType.BAR || this.chartType === ChartType.LINE || this.chartType === ChartType.AREA || this.chartType === ChartType.RADAR;
	}

	get selectedDimensionsForDropDownAxis() {
		if (isNil(this.internalChartConfig) || isNil(this.internalChartConfig.axisDimensions))
			return [];

		return this.internalChartConfig.axisDimensions.map(ad => ad.name);
	}

	get selectedTitle() {
		if (isNil(this.internalChartConfig) || isNil(this.internalChartConfig.title))
			return '';

		return this.internalChartConfig.title;
	}

	get selectedDimensionsForListAxis() {
		if (isNil(this.internalChartConfig) || isNil(this.internalChartConfig.axisDimensions))
			return [];

		return this.internalChartConfig.axisDimensions;
	}

	get availableDimensionsForAxis() {
		const result = (this.globalDimensions ?? []).map(dim => ({
			...dim,
			caption: this.$t(dim.name)
		}));
		if (Array.isArray(this.timeDimensions) && this.timeDimensions.length) {
			const timeDimension = first(this.timeDimensions).dimension;
			result.push({
				...timeDimension,
				caption: this.$t(timeDimension.name)
			});
		}
		return result;
	}

	get axisDimensionsSet() {
		if (isNil(this.internalChartConfig) || isNil(this.internalChartConfig.axisDimensions))
			return new Set();

		return new Set(this.internalChartConfig.axisDimensions.map(ad => ad.name));
	}

	get legendDimensionsSet() {
		if (isNil(this.internalChartConfig) || isNil(this.internalChartConfig.legendDimensions))
			return new Set();

		return new Set(this.internalChartConfig.legendDimensions.map(ld => ld.name));
	}

	get selectedDimensionsForListLegend() {
		if (isNil(this.internalChartConfig) || isNil(this.internalChartConfig.legendDimensions))
			return [];

		return this.internalChartConfig.legendDimensions;
	}

	get selectedDimensionsForDropDownLegend() {
		if (isNil(this.internalChartConfig) || isNil(this.internalChartConfig.legendDimensions))
			return [];

		return this.internalChartConfig.legendDimensions.map(ad => ad.name);
	}

	get availableDimensionsForLegend() {
		const result = (this.globalDimensions ?? []).map(dim => ({
			...dim,
			caption: this.$t(dim.name)
		}));
		if (Array.isArray(this.timeDimensions) && this.timeDimensions.length) {
			const timeDimension = first(this.timeDimensions).dimension;
			result.push({
				...timeDimension,
				caption: this.$t(timeDimension.name)
			});
		}
		return result;
	}

	get IsUserAdmin(): boolean {
		return (this.user.permissions as string[]).some(x => x == 'Dashboard.Admin');
	}

	onChangeAxisDimensionSelection({ addedItems, removedItems }: { addedItems: TCubeDimension[], removedItems: TCubeDimension[] }) {
		uiBus.emit(this.onAxisChangedEvent, { addedItems, removedItems });
	}

	onUserSelectionsChanged(currentVal, oldVal) {
		uiBus.emit(this.onUserSelectionChanged, { currentVal, oldVal });
	}

	filterAndMapFields(items: BaseCubeMember[]) {
		const toShowList = ['Dim_DataSegregation.companyCode', 'Dim_DataSegregation.companyBusinessName', 'Dim_DataSegregation.siteCode', 'Dim_DataSegregation.siteBusinessName'];

		return sortBy(items
			.filter(d => (!d.name.includes('.gen') && !d.name.startsWith('Dim_DataSegregation'))
				|| (d.name.includes('.gen') && this.genericFieldsDictionary[d.name])
				|| (d.name.startsWith('Dim_DataSegregation') && toShowList.includes(d.name)))
			.map(d => {
				const caption = this.$t(d.name);
				return {
					...d,
					caption,
					captionCode: d.name
				};
			}), itm => itm.caption);
	}

	parseUserSelection(currentVal, oldVal) {
		let isTimeDimensionSet = false, isDimensionSet = false, isMeasuresSet = false;

		isDimensionSet = isArrayWithAtLeastOneValue(currentVal.dimensions);
		isTimeDimensionSet = isArrayWithAtLeastOneValue(currentVal.timeDimensions);
		isMeasuresSet = isArrayWithAtLeastOneValue(currentVal.measures);

		return {
			isDimensionSet,
			isTimeDimensionSet,
			isMeasuresSet
		};

		function isArrayWithAtLeastOneValue(objectToCheck) {
			return !isNil(objectToCheck) && isArray(objectToCheck) && objectToCheck.length > 0;
		}
	}

	async setSelectedFieldForSortingIfPossible() {
		if (this.isDefaultOrderBy) {
			await this.$nextTick(() => {
				this.selectedFieldForSorting = this.fieldsForSortingDataSource.map(x => x.displayValue)[0];
			});
		}
		else {
			const orderKeys = Object.entries<string>(this.validatedQuery.order);
			if (orderKeys.length > 0) {
				const [[key, value]] = orderKeys;
				const test = this.fieldsForSortingDataSource.find(x => x.key === key && x.value === value)!;
				if (test)
					this.selectedFieldForSorting = test.displayValue;
			}
		}
	}

	onChangeMeasuresDropDownBoxValue({ addedItems, removedItems }: { addedItems: { name: string }[], removedItems: { name: string }[] }, setMeasures: (names: string[]) => void, measure: { name: string }[], setTimeDimension: any): void {
		if (addedItems.length > 0) {
			setMeasures([...measure.map(x => x.name), ...addedItems.map(x => x.name)]);
		} else if (removedItems.length > 0) {
			const removedNames = removedItems.map(x => x.name);
			setMeasures([...measure.map(x => x.name).filter(x => !removedNames.includes(x))]);
		}
	}

	onChangeDimensionsDropDownBoxValue({ addedItems, removedItems }: { addedItems: { name: string }[], removedItems: { name: string }[] }, setDimentions: (names: string[]) => void, dimentions: { name: string }[]): void {
		if (addedItems.length > 0)
			setDimentions([...dimentions.map(x => x.name), ...addedItems.map(x => x.name)]);
		else if (removedItems.length > 0) {
			const removedNames = removedItems.map(x => x.name);
			setDimentions([...dimentions.map(x => x.name).filter(x => !removedNames.includes(x))]);
		}
	}

	get isGranularityDefined() {
		return !isNil(this.granularity);
	}

	onChangeTimeDimensionsDropDownBoxValue() {
		if (!isNil(this.granularity)) {
			this.$emit('granularityPassed', this.granularity.name);
			let id = `${this.granularity.dimension}_${this.granularity.granularity}`;
			if (!isNil(this.dateRange))
				id = `${id}_${this.dateRange}`;

			this.internalTimeDimensionIds = [id];
			const timeDimension: any = {
				dimension: this.granularity.dimension,
				granularity: isNil(this.granularity) || this.granularity.granularity === 'week' ? 'day' : this.granularity.granularity
			};
			if (!isNil(this.dateRange)) {
				timeDimension.dateRange = this.dateRange;
			}

			if (!isNil(this.dateRange) && isNil(timeDimension.dateRange))
				timeDimension.dateRange = this.dateRange;

			this.setTimeDimensions([timeDimension]);
		}
	}

	onChangeSortingFieldDropDownBoxValue({ value: selectedValue }: { value: string }): void {
		if (selectedValue != this.selectedFieldForSorting)
			this.isDefaultOrderBy = false;

		if (isNil(selectedValue))
			this.selectedFieldForSorting = '';
		uiBus.emit(this.onSortingChangedEvent, selectedValue);
	}

	onChangeLegendDimensionSelection({ addedItems, removedItems }: { addedItems: TCubeDimension[], removedItems: TCubeDimension[] }) {
		uiBus.emit(this.onLegendChangedEvent, { addedItems, removedItems });
	}

	onChangeTitle({ value: newTitle, previousValue: oldTitle }: { value: string, previousValue: string }) {
		if (oldTitle.trim() !== newTitle.trim())
			uiBus.emit(this.onTitleChangedEvent, newTitle);
	}

	prepareSelectedItemsForClear(arr: string[]) {
		return Object.values(arr).map(x => ({ name: x }));
	}
}
